module.exports = __webpack_public_path__ + "static/media/image_8.28db5401.png";